import { allTrackers } from "app/services/track/track";

import { TRACK_EVENT_NAME } from "./constants";

export function trackEditTagsModalOpen() {
    allTrackers.dispatchTrackEvent("Pop up", "open", `${TRACK_EVENT_NAME}/Open`);
}
